import React from 'react'
import { LoadingSpinner, SettingsPage } from '@sales-center/components'
import { getSXStyles } from './styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { DefaultNoteCodeForm } from '@user/components/Settings/Notes/DefaultNoteCodeForm'
import { Formik } from 'formik'
import { useData } from '@user/components/Settings/Notes/hooks/useData'
import { useHandlers } from './hooks/useHandlers'

export function Notes() {
  const isMobile = useMediaQuery('(max-width:900px)')
  const styles = getSXStyles(isMobile)
  const { noteCodes, formDefaultValues, loading } = useData()

  const { onSubmit } = useHandlers()

  return (
    <SettingsPage padding="0">
      {loading ? (
        <Box minHeight="48px" pt={10}>
          <LoadingSpinner />
        </Box>
      ) : (
        <Box sx={styles.centered}>
          <Box sx={styles.title}>
            <Typography variant="h4" mt={5} mb={3.2} noWrap>
              Notes Settings
            </Typography>
          </Box>

          <Box sx={styles.main}>
            <Formik onSubmit={onSubmit} initialValues={formDefaultValues}>
              <DefaultNoteCodeForm
                noteCodes={noteCodes}
                formDefaultValues={formDefaultValues}
              />
            </Formik>
          </Box>
        </Box>
      )}
    </SettingsPage>
  )
}
